module.exports = __webpack_public_path__ + "src/img/eye.904bb290.svg";